import { render, staticRenderFns } from "./AddWatchList.vue?vue&type=template&id=5cd5be32&scoped=true&"
import script from "./AddWatchList.vue?vue&type=script&lang=js&"
export * from "./AddWatchList.vue?vue&type=script&lang=js&"
import style0 from "./AddWatchList.vue?vue&type=style&index=0&id=5cd5be32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5be32",
  null
  
)

export default component.exports